/* Query keys in one place, so the persistence rules in queryClient.ts can talk
   about them and the DR prefetch list stays honest. */

export const qk = {
  me: ['me'] as const,
  people: ['people'] as const,
  /* The Onboarding app's role templates and cases. Read live from its own site. */
  joinerTemplates: ['joiner-templates'] as const,
  joinerCases: ['joiner-cases'] as const,
  groups: ['groups'] as const,
  devices: ['devices'] as const,
  assignments: ['assignments'] as const,
  /* Per person, and deliberately NOT in DR_QUERY_KEYS: this is a live read of
     Entra, and a cached copy of somebody's group membership is the one thing
     that must not be answered from yesterday. */
  directoryAccess: (graphId: string) => ['directory-access', graphId] as const,
  /* Keyed on email, not graphId: the Training Matrix's employee list joins on
     the mailbox, which is not the sign-in name here. Live for the same reason
     as directoryAccess — somebody may have been scoped in SharePoint since. */
  trainingScope: (email: string) => ['training-scope', email] as const,
  trainingDepartments: ['training-departments'] as const,
  device: (tag: string) => ['devices', tag] as const,
  licences: ['licences'] as const,
  networks: ['networks'] as const,
  locations: ['locations'] as const,
  applications: ['applications'] as const,
  suppliers: ['suppliers'] as const,
  domains: ['domains'] as const,
  backups: ['backups'] as const,
  plans: ['plans'] as const,
  tests: ['tests'] as const,
  articles: ['articles'] as const,
  templates: ['templates'] as const,
  runs: ['runs'] as const,
  credentials: ['credentials'] as const,
  audit: ['audit'] as const,
  recordTypes: ['record-types'] as const,
  customRecords: (typeId?: string) => ['custom-records', typeId ?? 'all'] as const,
  statusTiles: ['status-tiles'] as const,
  attachments: (recordId: string) => ['attachments', recordId] as const,
  modules: ['modules'] as const,
  settings: ['settings'] as const,
  roles: ['roles'] as const,
  sync: ['sync'] as const,

} as const;

/* Pinned for offline. Handover §7 rule 4: this is the whole point — the recovery
   plans, network documentation, supplier account numbers and credential index
   are on the phone before the incident, not fetched during it. */
export const DR_QUERY_KEYS: readonly (readonly string[])[] = [
  qk.plans,
  qk.backups,
  qk.networks,
  qk.locations,
  qk.suppliers,
  qk.credentials,
  qk.articles,
  qk.devices,
  qk.people,
  qk.groups,
];
